/*
 * Replace all SVG images with inline SVG
 */
global.imgToSvg = function(target, bypassExceptions, callback, callbackData){
    target.find('img[src*=".svg"].svg').each(function () {
        if (!$(this).closest('.iv__item__image').length || bypassExceptions) {
            const $img = jQuery(this);
            const imgID = $img.attr('id');
            const imgClass = $img.attr('class');
            const imgURL = $img.attr('src');
            const imgType = imgURL.split('?')[0].split('.').pop().toLowerCase();

            if (imgType === 'svg') {
                jQuery.get(imgURL, function (data) {
                    // Get the SVG tag, ignore the rest
                    let $svg = jQuery(data).find('svg');

                    // Add replaced image's ID to the new SVG
                    if (typeof imgID !== 'undefined') {
                        $svg = $svg.attr('id', imgID);
                    }
                    // Add replaced image's classes to the new SVG
                    if (typeof imgClass !== 'undefined') {
                        $svg = $svg.attr('class', imgClass + ' replaced-svg');
                    }

                    // Remove any invalid XML tags as per http://validator.w3.org
                    $svg = $svg.removeAttr('xmlns:a');

                    // Replace image with new SVG
                    $img.replaceWith($svg);

                    if ($svg.hasClass('svg--fit')) {
                        ajusterViewBox($svg[0]);
                    }

                    // Callback
                    if (typeof callback === 'function') {
                        callback($svg, callbackData);
                    }
                }, 'xml');
            }
        }
    });
}



function ajusterViewBox(svgElement) {
    // Récupérer les dimensions du contenu du SVG
    const boundingBox = svgElement.getBBox();

    // Créer un nouveau viewBox basé sur les dimensions du contenu
    const nouveauViewBox = `${boundingBox.x} ${boundingBox.y} ${boundingBox.width} ${boundingBox.height}`;

    // Définir le nouveau viewBox sur l'élément SVG
    svgElement.setAttribute('viewBox', nouveauViewBox);


    // Ajouter width et height à l'élément SVG si non définis
    if (!svgElement.getAttribute('width')) {
        svgElement.setAttribute('width', boundingBox.width);
    }
    if (!svgElement.getAttribute('height')) {
        svgElement.setAttribute('height', boundingBox.height);
    }
  }